import { useNavigate, Link } from 'react-router-dom';
import abogaliaIcon from '../../icon.png';
import InstagramIcon from "../assets/instagram-icon.svg";
import FacebookIcon from "../assets/facebook-icon.svg";
import TikTokIcon from "../assets/tiktok-icon.svg";
import XIcon from "../assets/x-icon.svg";

export function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-neutral-900 dark:bg-black text-neutral-400 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src={abogaliaIcon}
                alt="Logo" 
                className="ml-2 h-8 w-auto"
              />
              <span className="text-xl font-bold text-white">Abogalia</span>
            </div>
            <p>Conectando personas con justicia</p>
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="https://www.instagram.com/abogalia_ia/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-neutral-400 hover:text-white transition-colors"
              >
                <img src={InstagramIcon} alt="Instagram" className="h-5 w-5" />
              </a>
              <a 
                href="https://www.facebook.com/Abogalia.ia" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-neutral-400 hover:text-white transition-colors"
              >
                <img src={FacebookIcon} alt="Facebook" className="h-5 w-5" />
              </a>
              <a 
                href="https://www.tiktok.com/@abogalia_ia" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-neutral-400 hover:text-white transition-colors"
              >
                <img src={TikTokIcon} alt="TikTok" className="h-5 w-5" />
              </a>
              <a 
                href="https://x.com/AbogaliaOK" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-neutral-400 hover:text-white transition-colors"
              >
                <img src={XIcon} alt="X" className="h-5 w-5" />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Producto</h3>
            <ul className="space-y-2">
              {/*<li className="cursor-pointer hover:text-white transition-colors">Cómo funciona</li>
              <li className="cursor-pointer hover:text-white transition-colors">Precios</li>*/}
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/how-work-lawyer')}>Para abogados</li>
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/how-work')}>Para clientes</li>
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/lawyer/directory/ranking')}>Mejores abogados</li>
              <li><Link className="hover:text-white transition-colors" to="/blog/mejores-abogados-argentina">Cómo elegir abogado</Link></li>
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/faqs')}>FAQs</li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Compañía</h3>
            <ul className="space-y-2">
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/about-us')}>Sobre nosotros</li>
              {/*<li className="cursor-pointer hover:text-white transition-colors">Blog</li>
              <li className="cursor-pointer hover:text-white transition-colors">Prensa</li>*/}
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/contact')}>Contacto</li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/tyc')}>Términos de servicio</li>
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/privacy-policy')}>Política de privacidad</li>
              <li className="cursor-pointer hover:text-white transition-colors" onClick={() => navigate('/cookies')}>Cookies</li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Especialidades</h3>
            <ul className="space-y-2">
              <li><Link className="hover:text-white transition-colors" to="/abogado/laboral-caba">Abogado laboral en CABA</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/abogado/familia-caba">Abogado de familia en CABA</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/abogado/civil-caba">Abogado civil en CABA</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/abogado/penal-caba">Abogado penal en CABA</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/abogado/consumo-caba">Abogado del consumidor en CABA</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/abogado/sucesiones-caba">Abogado de sucesiones en CABA</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-neutral-800 dark:border-neutral-900 mt-12 pt-8 text-center">
          <p>&copy; {new Date().getFullYear()} Abogalia. Todos los derechos reservados.</p>
          <p>Abogalia SAS - Sociedad por Acciones Simplificada registrada en la República Argentina.          </p>
        </div>
      </div>
    </footer>
  );
}